import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';

@Component({
    selector: 'eas-editor-booking-item-bundle-form',
    templateUrl: './editor-booking-item-bundle-form.component.html',
    styleUrls: ['./editor-booking-item-bundle-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemBundleFormComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemBundle: string[];
  @Input() parentFormGroup: FormGroup;
  @Input() itemBundleForm: FormControl;
  @Input() itemSiblings: string[];

  private destroyed$ = new Subject<void>();

  bookingItemNames: { id: string, name: string }[];
  availableBundleNames: { id: string, name: string }[];

  originalItemBundle: string[];
  originalItemBundleFormValue: any;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.bookingItemNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingItemNames => {
        this.bookingItemNames = bookingItemNames;
        this.updateAvailableBundleNames();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemBundle) {
      this.originalItemBundle = [...changes.itemBundle.currentValue];
    }
    if (changes.itemBundleForm && changes.itemBundleForm.currentValue.value !== undefined) {
      this.originalItemBundleFormValue = [...changes.itemBundleForm.currentValue.value];
    }
    if (changes.itemSiblings) {
      if (this.bookingItemNames !== undefined) {
        this.updateAvailableBundleNames();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  isDeletable() {
    return this.itemBundleForm.value.length > 0;
  }

  onDelete() {
    this.itemBundleForm.markAsDirty();
    this.itemBundleForm.setValue([]);
    return false;
  }

  updateAvailableBundleNames() {
    this.availableBundleNames = this.bookingItemNames.filter(
      bookingItemName => this.itemSiblings.includes(bookingItemName.id)
    );
  }
}
